export default __webpack_public_path__ + "static/media/ARPA-BNB.c8bc7230.svg";